var Track = function (action, data) {
    try {
        gtag('event', action, data);
    } catch (err) {
        console.log("err event:", err.message);
    }
};

var copyToClipboard = function(elem) {
    // create hidden text element, if it doesn't already exist
    var targetId = "_hiddenCopyText_";
    var isInput = elem.tagName === "INPUT" || elem.tagName === "TEXTAREA";
    var origSelectionStart, origSelectionEnd;
    if (isInput) {
        // can just use the original source element for the selection and copy
        target = elem;
        origSelectionStart = elem.selectionStart;
        origSelectionEnd = elem.selectionEnd;
    } else {
        // must use a temporary form element for the selection and copy
        target = document.getElementById(targetId);
        if (!target) {
            var target = document.createElement("textarea");
            target.style.position = "absolute";
            target.style.left = "-9999px";
            target.style.top = "0";
            target.id = targetId;
            document.body.appendChild(target);
        }
        target.textContent = elem.textContent;
    }
    // select the content
    var currentFocus = document.activeElement;
    target.focus();
    target.setSelectionRange(0, target.value.length);

    // copy the selection
    var succeed;
    try {
        succeed = document.execCommand("copy");
    } catch (e) {
        succeed = false;
    }
    // restore original focus
    if (currentFocus && typeof currentFocus.focus === "function") {
        currentFocus.focus();
    }

    if (isInput) {
        // restore prior selection
        elem.setSelectionRange(origSelectionStart, origSelectionEnd);
    } else {
        // clear temporary content
        target.textContent = "";
    }
    return succeed;
}

var App = function ($) {

    var cookie = {
        set: function (name, value) {
            document.cookie = name + '=' + value + ';path=/';
        },
        get: function (name) {
            var cookie, cookies_object = {},
                cookies_array = document.cookie.split(';').map(function (x) {
                    return x.replace(/ /g, '').split("=");
                });
            for (var i in cookies_array) {
                cookie = cookies_array[i];
                cookies_object[cookie[0]] = cookie[1];
            }
            return cookies_object[name];
        },
        delete: function (name) {
            cookie.set(name, '');
        },
        clear: function () {
            App.cookie.set('clear_cache', true);
        }
    };

    var resize = {
        home: function(){
            var max_p_height = 0;
            var max_p_text_height = 0;
            var postcardHeight = $('#postcards ul').height();
            var slides = $('#home-hero ul.slides');

            $('.p-cat .fusion-builder-row').each(function(){
                $(this).height('auto');
            })
            $('.p-cat .descripcion').each(function(){
                $(this).height('auto');
            })
            $('.p-cat .fusion-builder-row').each(function(){
                max_p_height = Math.max(max_p_height,$(this).height())
            })
            $('.p-cat .descripcion').each(function(){
                max_p_text_height = Math.max(max_p_text_height,$(this).height())
            })
            $('.p-cat .fusion-builder-row').each(function(){
                $(this).height(max_p_height);
            })
            $('.p-cat .descripcion').each(function(){
                $(this).height(max_p_text_height);
            })
            slides.each(function(){
                var slide = $(this);
                var bg = $(this).find('.background');
                //bg.height(bg.width()*1040/2560);
            })
        },
        product: function(){
            var img = $('#product-description .fusion-imageframe img');
            var img_size = {
                width: parseInt(img.attr('width')),
                height: parseInt(img.attr('height'))
            };
            var container = $('#product-description .fusion-imageframe');
            var coef_cont = container.width()/container.height();
            var coef_img = img_size.width / img_size.height;
            if (coef_img>coef_cont){
                img.height(container.height()).width(container.height()*coef_img);
            } else {
                img.width(container.width()).height(container.width()/coef_img);
            }
            var carousel = $('.related-posts ul');
            var max_height = 0;
            carousel.find('.fusion-image-wrapper').each(function(){
                max_height = Math.max(max_height,$(this).height());
            })
            carousel.find('.fusion-image-wrapper').each(function(){
                $(this).height(max_height);
                $(this).find('a').css({top:(max_height-$(this).find('img').height())/2});
            })
        },
    }

    var translate = {
        replace: function (condition, target, search, replace){
            if ($(condition).length){
                $(target).each(function(){
                    $(this).html($(this).html().replace(search,replace));
                })
            }
        },
        process: function(array){
            var translation;
            for (var i in array){
                translation = array[i];
                translate.replace(translation.condition!==undefined?translation.condition:translation.target,translation.target,translation.search,translation.replace);
            }
        }
    }

    var init = function () {

        if ($('.modal').length) {
            $('.modal').on('show.bs.modal', function () {
                setTimeout(function () {
                    $(window).trigger('fusion-resize-horizontal');
                }, 500);
            })
        }

        if ($('body.home').length){
            $(window).resize(function(){
                resize.home();
            })
        }

        if ($('#product-description').length){
            $(window).resize(function(){
                resize.product();
            })
        }

        if ($('input[placeholder="Search..."]').length){
            $('input[placeholder="Search..."]').attr('placeholder','Buscar...');
        }

        if ($('.postcard').length){
            $('.postcard').each(function(){
                var content = $(this).find('.content p'); 
                if(content.html().indexOf('[...]')===-1 && content.html().split(' ').length>30){
                    content.html(content.html().split(' ').splice(0,30).join(' ')+'[..]');
                }
            })
        }

        $('a[href="#"]').on('click',function(e){
            e.preventDefault();
        });

        $('.ga-track').on('click', function (e) {
            var t = $(this);
            Track(t.data('action'), {
                'event_category': t.data('category'),
                'event_label': t.data('label')
            });
        });

        var translations = [
            {
                condition: '.fusion-meta-tb',
                target: '.fusion-meta-tb',
                search: 'Categories',
                replace: 'Categorías'
            },
            {
                condition: '.home',
                target: '.postcard .fusion-tb-categories',
                search: 'Categories: ',
                replace: ''
            },
            {
                target: 'a[data-dismiss="modal"], button[data-dismiss="modal"]',
                search: 'Close: ',
                replace: 'Cerrar'
            },
            {
                condition: 'body.search',
                target: '.fusion-title h1',
                search: 'Search:',
                replace: 'Búsqueda:'
            }
        ]

        translate.process (translations);
        $(window).trigger('resize');
    };

    return {
        init: init,
        translate: translate,
        cookie: cookie
    };
}(jQuery);

jQuery(function () {
    App.init();
});